export const SURVEY_PATH = '/survey';

export const SURVEY_NAV_BAR_HEIGHT = `calc(5rem + env(safe-area-inset-top))`;
